import { createAction } from 'typesafe-actions'
import { InitParametersState } from '../../reducers/initParametersReducer'

export const setInitParametersToState = createAction('DOC / InitParameters / set state')<InitParametersState>()

export const resetVehicleCodeInState = createAction('DOC / InitParameters / reset vehicle code in state')()
